import { ListAggregatorAccount } from '~/features/common/Taxipark/AggregatorAccount/ListAggregatorAccount'
import { Container } from '~/shared/ui/Layout'

export const ListAggregatorAccountPage = () => {
  return (
    <Container>
      <ListAggregatorAccount />
    </Container>
  )
}
